/**
 * Predictive-panel metric registry — extracted from PredictivePanel.tsx
 * so App.tsx can import the metric-to-layer map WITHOUT pulling in the
 * whole predictive panel (chart, sparkline, alert chip) on the initial
 * bundle. The map is small (~200 bytes) and the panel is heavy.
 *
 * If a new forecast metric is added, register it here AND in
 * apps/forecast/ (Python service). Missing-in-app is a silent no-op;
 * missing-in-forecast is a 404 — both are caught by the test below.
 */

import type { LayerId } from "../map/presets";

export const METRIC_LAYER_MAP: Record<string, { layers: LayerId[]; flyToCoast?: boolean }> = {
  "precipitation.forecast": { layers: ["satellite-imerg"] },
  "incidentRate.forecast":  { layers: ["incidents-city-reports"] },
  "aqi.forecast":           { layers: ["satellite-aerosol", "satellite-no2"] },
  // Water-specific forecasts. damStorage and riverLevel don't auto-toggle
  // map layers in the conventional sense — they show up in the
  // WaterSecurityHero forecast strip instead. The mapping is still
  // useful for the alert badge to know "this forecast is about the
  // flood-risk layer / waterways layer" so the panel header can
  // highlight it.
  "damStorage.forecast":    { layers: ["flood-risk-zones", "lam-takhong"] },
  "riverLevel.forecast":    { layers: ["waterways", "lam-takhong"] },
};

/** Human-readable metric names for the ForecastAlertBadge. */
export const METRIC_LABEL: Record<string, string> = {
  "precipitation.forecast": "RAIN",
  "incidentRate.forecast":  "INCIDENTS",
  "aqi.forecast":           "AQI",
  "damStorage.forecast":    "DAM",
  "riverLevel.forecast":    "RIVER",
};
